module.exports = __webpack_public_path__ + "img/broatcast-step3.a8ec6a58.png";